import { create } from 'zustand';

const AC_SIDEBAR_EXPANDED = 'ac_sidebar_expanded';

function readSidebarExpanded(): boolean {
  if (typeof window === 'undefined') return true;
  return localStorage.getItem(AC_SIDEBAR_EXPANDED) !== 'false';
}

const isMobileDevice = typeof window !== 'undefined' && (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || window.innerWidth <= 768);
const isStandalone = typeof window !== 'undefined' && (window.matchMedia('(display-mode: standalone)').matches || (window.navigator as any).standalone || localStorage.getItem('ac_pwa_standalone') === 'true');

// PWA or Mobile default to light mode (unless set otherwise)
const defaultDark = false;

function readDarkMode(): boolean {
  if (typeof window === 'undefined') return false;
  const stored = localStorage.getItem('darkMode');
  if (stored === null) return defaultDark;
  return stored === 'true';
}

/** Estado global de UI: dark mode e sidebar (Zustand) */
export interface UiState {
  darkMode: boolean;
  sidebarOpen: boolean;
  /** Barra lateral desktop: true = rótulos visíveis, false = só ícones. Padrão: expandido. */
  sidebarExpanded: boolean;
  toggleDarkMode: () => void;
  toggleSidebar: () => void;
  setSidebarOpen: (open: boolean) => void;
  setSidebarExpanded: (expanded: boolean) => void;
  toggleSidebarExpanded: () => void;
}

export const useUiStore = create<UiState>((set) => ({
  darkMode: readDarkMode(),
  sidebarOpen: true,
  sidebarExpanded: readSidebarExpanded(),
  toggleDarkMode: () => set((s) => {
    const next = !s.darkMode;
    if (typeof window !== 'undefined') {
      localStorage.setItem('darkMode', next ? 'true' : 'false');
      if (next) {
        document.documentElement.classList.add('dark');
      } else {
        document.documentElement.classList.remove('dark');
      }
    }
    return { darkMode: next };
  }),
  toggleSidebar: () => set((s) => ({ sidebarOpen: !s.sidebarOpen })),
  setSidebarOpen: (open) => set({ sidebarOpen: open }),
  setSidebarExpanded: (expanded) => {
    if (typeof window !== 'undefined') {
      localStorage.setItem(AC_SIDEBAR_EXPANDED, expanded ? 'true' : 'false');
    }
    set({ sidebarExpanded: expanded });
  },
  toggleSidebarExpanded: () => {
    set((s) => {
      const next = !s.sidebarExpanded;
      if (typeof window !== 'undefined') {
        localStorage.setItem(AC_SIDEBAR_EXPANDED, next ? 'true' : 'false');
      }
      return { sidebarExpanded: next };
    });
  },
}));

// Apply dark mode state on boot
if (typeof window !== 'undefined') {
  const isDark = readDarkMode();
  if (isDark) {
    document.documentElement.classList.add('dark');
  } else {
    document.documentElement.classList.remove('dark');
  }
}
